// extracted by mini-css-extract-plugin
export default {"container":"Header_container__7Ai+3","discs":"Header_discs__1FvHE"};